import React from "react";
import { BarChart3 } from "lucide-react";
import "./AllUsersUsageModal.css";
import useFormatDate from "../../../hooks/useFormatDate";
import { useTranslation } from "react-i18next";
import ButtonClose from "../../components/Buttons/ButtonClose/ButtonClose";

export default function AllUsersUsageModal({ isOpen, onClose, record }) {
  const formatDate = useFormatDate();
  const { t } = useTranslation('usage');
  if (!isOpen || !record) return null;

  const safe = (v) => (v === 0 || v ? v : "-");

  return (
    <div className="usage-modal-overlay" onClick={onClose}>
      <div
        className="usage-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="usage-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="usage-modal-header">
          <div className="usage-modal-title-section">
            <BarChart3 size={20} aria-hidden="true" className="usage-modal-icon" />
            <h2 id="usage-modal-title" className="usage-modal-title">
              {record?.user?.name || "-"}
            </h2>
          </div>
          <ButtonClose
            onClick={onClose}
            ariaLabel={t('common:aria.close', { defaultValue: 'Close' })}
            size={18}
          />
        </div>

        <div className="usage-modal-content">
          <div className="usage-modal-section">
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.email')}</span>
              <span className="usage-value">{safe(record?.user?.email)}</span>
            </div>
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.credits')}</span>
              <span className="usage-value">
                {record?.credits != null
                  ? (Math.round(record.credits * 10) / 10).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "-"}
              </span>
            </div>
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.usageDate')}</span>
              <span className="usage-value">{record?.usage_date ? formatDate(record.usage_date) : "-"}</span>
            </div>
          </div>

          <div className="usage-modal-section grid">
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.messages')}</span>
              <span className="usage-value">{safe(record?.final_responses)}</span>
            </div>
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.iterations')}</span>
              <span className="usage-value">{safe(record?.iterations)}</span>
            </div>
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.toolCalls')}</span>
              <span className="usage-value">{safe(record?.tool_calls)}</span>
            </div>
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.prompts')}</span>
              <span className="usage-value">{safe(record?.prompts)}</span>
            </div>
          </div>

          <div className="usage-modal-section">
            <div className="usage-field">
              <span className="usage-label">{t('allUsers.table.agent')}</span>
              <span className="usage-value">{safe(record?.llm_model_name)}</span>
            </div>
          </div>
        </div>

        {/* Footer actions intentionally removed per request */}
      </div>
    </div>
  );
}
